module.exports = __webpack_public_path__ + "img/Group 3918.d1d7e2d9.svg";